import { useAppSettingStore } from '../store/app-store';
import { useAuth } from './use-auth';
import { getNextPageParam, getPreviousPageParam } from '@/libs/react-sdk/utils';
import { ApiInstance, UserTransactionParams } from '@/libs/sdk/api';
import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';

export const useSingedTransaction = (api: ApiInstance, params?: Partial<UserTransactionParams>) => {
  const baseToken = useAppSettingStore(state => state.baseToken);
  const { page = 1, pageSize = 10, baseTokenAddress = baseToken.address } = params || {};
  const { data } = useAuth();
  const uid = data?.uid;
  return useInfiniteQuery({
    enabled: !!uid,
    queryKey: ['SingedTransaction', api, uid, baseTokenAddress, params],
    initialPageParam: { page, pageSize },
    queryFn: async ({ pageParam }) => {
      const { data } = await api.user.getUserTransactions({ ...params, baseTokenAddress, ...pageParam });
      return { ...data, ...pageParam };
    },
    placeholderData: keepPreviousData,
    getPreviousPageParam,
    getNextPageParam,
  });
};
